import { PRICE_SERVICE_URL } from "@umami/swap/src/env";
import { useCallback, useEffect, useState } from "react";

export interface FastWithdrawalRates {
  min: number | null;
  max: number | null;
  rate: number | null;
}

export function useFastWithdrawalRates(enabled: boolean) {
  const [rates, setRates] = useState<FastWithdrawalRates>({ min: null, max: null, rate: null });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchRates = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${PRICE_SERVICE_URL}/fastWithdrawalRates`, { method: "POST" });
      const data = await res.json();
      const providers = data.data?.data;
      const validProviders = Array.isArray(providers)
        ? providers.filter((p: any) => parseFloat(p.rate) > 0)
        : [];

      if (!res.ok || validProviders.length === 0) {
        throw new Error(data.error || "No fast withdrawal providers available");
      }
      const provider = validProviders.reduce((best: any, curr: any) =>
        parseFloat(curr.rate) < parseFloat(best.rate) ? curr : best
      );
      setRates({
        min: provider.min_amount_mutez ? Number(provider.min_amount_mutez) / 1e6 : null,
        max: provider.max_amount_mutez ? Number(provider.max_amount_mutez) / 1e6 : null,
        rate: provider.rate !== undefined ? parseFloat(provider.rate) : null,
      });
    } catch (err: any) {
      setError(err.message || "Failed to fetch fast withdrawal rates");
      setRates({ min: null, max: null, rate: null });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (enabled) {
      void fetchRates();
    }
  }, [enabled, fetchRates]);

  return { ...rates, loading, error, refetch: fetchRates };
}
